import { ConfigurePointerText } from "../ConfigurePointerText/ConfigurePointerText";
import { ConfigureHoverAction } from "../ConfigureHoverAction/ConfigureHoverAction";
import { ConfigureClickAction } from "../ConfigureClickAction/ConfigureClickAction";
import { steps } from "../../util/constants";
import { useDispatch } from "react-redux";
import { setCurrentStep } from "../../redux";
import HotspotCardHeader from "../HotspotCardHeader/HotspotCardHeader";

export default function HotspotCard({ disabled }) {
  const dispatch = useDispatch();
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        height: "calc(100% - var(--hse-line-height))",
        pointerEvents: disabled ? "none" : "auto",
        opacity: disabled ? 0.14 : 1,
      }}
    >
      <div style={{ flex: "0 0 var(--hse-line-height)" }}>
        <HotspotCardHeader />
      </div>
      <div style={{ flex: "1 1 100%", overflowY: "auto" }}>
        <ConfigureClickAction
          onChange={(e) => dispatch(setCurrentStep(steps.configureClickAction))}
          style={{ padding: "1rem 0.5rem 0.5rem 0.5rem" }}
        />
        <ConfigureHoverAction
          onChange={(e) => dispatch(setCurrentStep(steps.configureHoverAction))}
          style={{ padding: "1rem 0.5rem 0.5rem 0.5rem" }}
        />
        <ConfigurePointerText
          onChange={(e) => dispatch(setCurrentStep(steps.configurePointerText))}
          style={{ padding: "1rem 0.5rem 0.5rem 0.5rem" }}
        />
      </div>
    </div>
  );
}
